export const agenda = {
  agendaDuration: 'Dauer',
  agendaCurtainCopy: 'Link kopieren',
  agendaCurtainFlag: 'Melden',
  agendaCurtainFlagSent: 'Inhalt gemeldet',
  agendaLinkCopied: 'Link kopiert!',
  agendaStartsAt: 'Beginnt um ',
  agendaEndsAt: 'Endet um ',
  agendaSpeakers: 'Redner',
  agendaSeeAllSpeakers: 'Alle anzeigen',
  agendaAddToSchedule: 'Zum Zeitplan hinzufügen',
  agendaRemoveFromSchedule: 'Vom Zeitplan entfernen',
  agendaAddedToSchedule: 'Zum Zeitplan hinzugefügt!',
  agendaRemovedFromSchedule: 'Vom Zeitplan entfernt!',
  agendaCalendar: 'Kalender',
  agendaAddToCalendar: 'Zum Systemkalender hinzufügen?',
  agendaCalendarSkip: 'Überspringen',
  agendaCalendarAdd: 'Hinzufügen',
  agendaNow: 'JETZT',
  agendaModerators: 'Moderatoren',

  QnATitle: 'Fragen & Antworten',
  askASpeaker: 'Einen Sprecher fragen',
  askAQuestion: 'Eine Frage stellen',
  askQuestionPlaceholder: 'Geben Sie hier Ihre Frage ein',
  cancel: 'Abbrechen',
  ask: 'Fragen',
  deleteConfirmation: 'Möchten Sie diese Frage löschen?',
  questionDeleted: 'Frage erfolgreich gelöscht!',
  rateSession: 'Bewerten Sie diese Sitzung'
}
